(function () {
  'use strict';

  var ATTR = 'data-product-list-swiper';
  var instances = new WeakMap();

  function syncNavigationHeight(shell) {
    if (!shell) return;
    var figure = shell.querySelector('.idx-card__figure');
    if (!figure) return;
    var height = figure.getBoundingClientRect().height;
    if (height > 0) shell.style.setProperty('--product-list-media-height', height + 'px');
  }

  function init(root) {
    if (!root || instances.has(root) || typeof Swiper === 'undefined') return;

    var slideCount = root.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var shell = root.closest('.product-list-shell');
    var navRoot = shell ? shell.querySelector('.swiper-buttons') : root.querySelector('.swiper-buttons');
    var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : null;
    var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : null;

    var swiper = new Swiper(root, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      threshold: 8,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
    });

    syncNavigationHeight(shell);

    var resizeObserver = null;
    var resizeHandler = null;
    var figure = shell ? shell.querySelector('.idx-card__figure') : null;
    if (figure && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        syncNavigationHeight(shell);
      });
      resizeObserver.observe(figure);
    } else {
      resizeHandler = function () {
        syncNavigationHeight(shell);
      };
      window.addEventListener('resize', resizeHandler);
    }

    instances.set(root, {
      swiper: swiper,
      resizeObserver: resizeObserver,
      resizeHandler: resizeHandler,
    });
  }

  function destroyIn(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(function (root) {
      var instance = instances.get(root);
      if (!instance) return;
      if (instance.resizeObserver) instance.resizeObserver.disconnect();
      if (instance.resizeHandler) window.removeEventListener('resize', instance.resizeHandler);
      instance.swiper.destroy(true, true);
      instances.delete(root);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyIn(event.target);
  });
})();
